export default "__VITE_ASSET__82cc0827__"